import { MAX_FREE_GENERATIONS } from '@/features/ai-onboard/constants'
import { shouldRenderFreeGenerationBanner } from '../lib/freeGenerationBanner'

export function HomeFreeGenerationBanner({
  workspace,
  profile,
  loading,
  onUpgradeClick,
}) {
  if (!shouldRenderFreeGenerationBanner({ workspace, profile, loading })) {
    return null
  }

  const attempts = Number(profile?.preferences?.p_attempt || 0)
  const usedGenerations = Number.isFinite(attempts) ? attempts : 0
  const remainingGenerations = Math.max(0, MAX_FREE_GENERATIONS - usedGenerations)
  const hasGenerationsLeft = remainingGenerations > 0

  return (
    <aside
      aria-label="Free generation limit"
      className="w-full bg-[#a913b5]"
    >
      <button
        type="button"
        onClick={onUpgradeClick}
        className="flex min-h-10 w-full cursor-pointer items-center justify-center px-4 py-2 text-center text-[15px] font-normal leading-5 text-white transition-opacity hover:opacity-90 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white/80 sm:text-base"
      >
        <span className="max-w-full">
          {hasGenerationsLeft ? (
            <>
              Only{' '}
              <span className="font-bold">
                {remainingGenerations}/{MAX_FREE_GENERATIONS} generation
                {remainingGenerations === 1 ? '' : 's'} left
              </span>{' '}
              on your Free plan.
            </>
          ) : (
            <span className="font-bold">
              You have used all free generations in your Free plan.
            </span>
          )}{' '}
          <span className="font-bold underline underline-offset-2">
            Upgrade
          </span>{' '}
          to the Growth or Scale plan to keep generating more designs.
        </span>
      </button>
    </aside>
  )
}
